function refreshList() {
    var favourites = ($('form#form-favourites').length!==0) ? true : false;
    var fulltext = ($('#search-results').length!==0) ? true : false;
    if(favourites) {
		var ajaxData = "sortby="+$("select#sort-select").val()+"&favourites=1&f=refreshFavList";
    } else if(fulltext) {
		var ajaxData = $("form#search").serialize()+"&"+$("form#filter").serialize()+"&f=refreshFulltext";
    } else {
		if($("input[name=sortby-over]").val()!=="") { var sortby = $("input[name=sortby-over]").val(); }
		else { var sortby = $("select#sort-select").val();}
		var ajaxData = $("form#search").serialize()+"&"+$("form#filter").serialize()+"&sortby="+sortby+"&f=129c6fac3a2fa6cbc8aacfb481c0b8de";
    }

    $.ajax({
		type: "GET",
		url: "/ajax/",
		data: ajaxData,
		dataType: "json",
		beforeSend: function(){
			$("section#list").append('<div class="ajaxLoad"><span>načítám data</span></div>');
		},
		success: function(data){
			if(data.status===true){
			$("section#list").parent().html(data.html);
			if(data.meta!==undefined) {
				$("#main-title").text(data.meta.h1);
				document.title = data.meta.title;
			}
			window.history.pushState("", "", data.url);
			}
		},
		complete: function() {
			$(".ajaxLoad").remove();
			// LazyLoading
			jQuery("img").unveil(500, function () {
			jQuery(this).load(function () {
				this.style.opacity = 0;
				jQuery(this).animate({opacity: 1});
			});
			});
			jQuery('input.demand[type="checkbox"]').iCheck({
			inheritClass: true
			});
			jQuery(".sort-select-container.big select#sort-select").chosen({
			width: '100%',
			disable_search: true,
			inherit_select_classes: true
			}).change(function(){
				ga('send','event','razeni',document.URL,$('select#sort-select').val());
				refreshList();
			});
	//	    $("input.demand").on("ifToggled",function(){
	//		var demands = $("input.demand:checked").length;
	//		$(".demand-button .demand-count").html("("+demands+")");
	//		(demands>0) ? $(".demand-button").removeAttr("disabled") : $(".demand-button").attr("disabled","disabled");
	//	    });
		}
    });
    //$("section#list").append('<div style="width: 100%; height: 100%; background-color: rgba(255,255,255,.6); position: absolute; top: 0; left: 0;">načítám data</div>');
}

function refreshPrevioRows() {
	$("article[data-previo-id]").each(function(index,element){
		$.ajax({
			type: 'GET',
			url: '/ajax/',
			dataType: "json",
			data: {
				"f":"3c53c1d5eb6e5fb272ee5a77f0f5fcf0",
				"pid": $(element).data('previo-id'),
				"from": $('#search input[name="datum_od"]').val(),
				"to": $('#search input[name="datum_do"]').val()
			},
			success: function(data){
				if(data.status) {
					$(".previo-list-reservation",element).html(data.button);
					if(data.title!==undefined)$(".price",element).prepend("<small>"+data.title+"</small>");
				} else {
					$(".previo-list-reservation",element).html(data.html);
				}
			}
		});
	});
}

//function refreshStars(activeStar) {
//    if(activeStar.iCheck('update')[0].checked) {
//	var stars = activeStar.val();
//    } else {
//	var stars = 0;
//    }
//    $("form#filter input[name=pocetHvezdicek]:not([value="+stars+"])").removeAttr("checked");
//    $("form#filter input[name=pocetHvezdicek]").parent(".icon-star").removeClass("checked");
//    $("form#filter input[name=pocetHvezdicek]").each(function(){
//        if($(this).val()<=stars) {  $(this).parent(".icon-star").addClass("checked"); }
//    });
//    refreshList();
//}


$(document).ready(function(){
//    if($("form#filter input[name=pocetHvezdicek]:checked").length>0){
//	var activeStar = $("form#filter input[name=pocetHvezdicek]:checked");
//	refreshStars(activeStar);
//    }
});

//$("form#filter input:not([name=pocetHvezdicek])").on("ifToggled",function(){
//$("form#filter input").on("ifToggled",function(){
$("body").on("ifToggled","form#filter input",function(){
    refreshList();
});
$(".sort-select-container.big select#sort-select").chosen({
    width: '100%',
    disable_search: true,
    inherit_select_classes: true
}).change(function(){
    ga('send','event','razeni',document.URL,$('select#sort-select').val());
    refreshList();
});

$("body").on("change",".sort-select-container.small select#sort-select",function(){
    //console.log($(this).val());
    //$(".sort-select-container.big select#sort-select").val('');
    $("input[name=sortby-over]").val($(this).val());
    refreshList();
});

//$("form#filter input[name=pocetHvezdicek]").on("ifToggled",function(){
//    var activeStar = $(this);
//    refreshStars(activeStar);
//});

//$("input.demand").on("ifToggled",function(){
$("body").on("ifToggled","input.demand",function(){
    var demands = $("input.demand:checked").length;
    $(".demand-button .demand-count").html("("+demands+")");
    (demands>0) ? $(".demand-button").removeAttr("disabled") : $(".demand-button").attr("disabled","disabled");
});
$("body").on("click",".demand-button",function(){
    $.ajax({
	type: "GET",
	url: "/ajax/",
	data: $(".demand").serialize()+"&from="+$("#search input[name='datum_od']").val()+"&to="+$("#search input[name='datum_do']").val()+"&f=7d7d069edcd3077ce52b0e417642dfc2",
	dataType: "json",
	beforeSend: function(){

	},
	success: function(data){
	    if(data.status===true){
			$('body').append(data.content);
			$('#dostupnost').modal('show');
			$.each(data.firms,function(i,firm){
		    	ga('send','event', 'poptavka_hromadna', document.URL, data.firms[i]);
			});
			$('#dostupnost').on('hidden.bs.modal', function (e) {
				$(this).remove();
			});
	    }
	},
	complete: function() {
	    //gdprText();
        jQuery('#dostupnost input#gdpr_checkbox[type="checkbox"]').iCheck({
            inheritClass: true
        });
        jQuery("#modal-form #arrival, #modal-form #departure").datepicker({minDate:new Date,onSelect:function(){if("arrival"==this.id){var e=jQuery(this).datepicker("getDate"),t=new Date(e.getFullYear(),e.getMonth(),e.getDate()+1);jQuery("#modal-form #departure").datepicker("option","minDate",t)}checkObsazenost();}});
	}
    });
    return false;
});

$("form#search input,form#search select").on("change",function(){
    $("form#search button[name=submitSearchForm]").addClass("search-alert");
});

$("form#search button[name=submitSearchForm]").on("click",function(){
    if($(this).hasClass("search-alert")) {
	$(this).removeClass("search-alert");
    }
});

$(document).ready(function() {
	//console.log('xxxx');
	refreshPrevioRows();
});
